export const connectionChange = (connectionInfo) => ({
  type: 'CONNECTION_CHANGE',
  payload: {
    isOnline: connectionInfo.type !== 'none',
  },
});
